import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import SettingsList from "./settings/SettingsList";
import PageHeader from "common/PageHeader";
import TTPTab from "ui/tabs/TTPTab";
import TextModelList from "../text-model/TextModelList";

import _ from "i18n";
import { setCurrentNavPage } from "../../actions/actions/params";

export const MODELS_TAB = "texts";
export const MODELS_TEMPLATES_TAB = "library";

const GenericEmailPage = ({ isUAVersion = false, handleSetCurrentPage }) => {
  const [activeTab, setActiveTab] = useState(MODELS_TEMPLATES_TAB);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location?.search);

    dispatch(setCurrentNavPage("GENERIC_EMAILING"));

    const tab = query.get("tab");
    if ([MODELS_TEMPLATES_TAB, MODELS_TAB].includes(tab)) {
      setActiveTab(tab);
    }
  }, [location.search, dispatch]);

  const tabs = [
    { id: MODELS_TEMPLATES_TAB, label: "library" },
    { id: MODELS_TAB, label: "texts" },
  ];

  return (
    <div id="generic-emailing-page">
      <PageHeader
        header="Generic Emailing"
        subHeader="Create and manage your transactional emails."
        icon="GENERIC_EMAIL"
      >
        <button
          className="btn secondary text-uppercase"
          onClick={() =>
            isUAVersion
              ? handleSetCurrentPage("GENERIC_EMAIL_FORM", null, {
                  genericSettingId: null,
                })
              : navigate("/email")
          }
        >
          <img src="/img/icons/add.svg" alt="Add" />
          {_("Manage your emails")}
        </button>
      </PageHeader>
      <div className="ttp-tab-container">
        <TTPTab tabs={tabs} activeTab={activeTab} selectTab={setActiveTab} />
        <SettingsList
          visible={activeTab === MODELS_TEMPLATES_TAB}
          isUAVersion={isUAVersion}
          handleSetCurrentPage={handleSetCurrentPage}
        />
        {activeTab === MODELS_TAB && (
          <TextModelList isGenericEmailPage={true} isUAVersion={isUAVersion} />
        )}
      </div>
    </div>
  );
};

export default GenericEmailPage;
